import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IToken {
  jwtToken: string;
}

@Injectable({
  providedIn: 'root'
})
export class MemberFirebaseTokenService {

  constructor(private httpClient: HttpClient,
    private httpHeaderService: HttpHeadersService) { }
  
  public get(): Observable<IToken> {
    const headers = this.httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this.httpClient.get(environment.servicePath + '/maintenance/token', { headers });
    return result as Observable<IToken>;
  }
}
